import error from "./errors";
import fields from "./fields";

export default {
  error,
  fields,
  app: {
    title: "Legalizaciones"
  },
  btn: {
    next: "Siguiente",
    prev: "Anterior",
    cancel: "Cancelar",
    back: "Volver atrás",
    cambiar: "Cambiar",
    search: "Buscar trámite",
    solicitar: "Solicitar",
    finalizar: "Ir al inicio",
    verificar: "Verificar",
    register: "Registrando...",
    solicitando: "Solicitando...",
    cerrarsession: "Cerrar Sessión"
  },
  months: {
    enero: "Enero",
    febrero: "Febrero",
    marzo: "Marzo",
    abril: "Abril",
    mayo: "Mayo",
    junio: "Junio",
    julio: "Julio",
    agosto: "Agosto",
    septiembre: "Septiembre",
    octubre: "Octubre",
    noviembre: "Noviembre",
    diciembre: "Diciembre"
  },
  menu: {
    inicio: "Inicio",
    home: "Inicio",
    tramite: "Trámites",
    solicitud: "Solicitud",
    seguimiento: "Seguimiento",
    verificar: "Verificar",
    contacto: "Contacto"
  },
  inicio: {
    title: "PLATAFORMA DE LEGALIZACIONES y CERTIFICACIONES",
    detalle:
      "La nueva plataforma de legalizaciones y certificaciones que está para brindarte mejores condiciones.",
    btnSolicitar: "Solicitar",
    btnSeguimiento: "Estado de mi solicitud",
    btnVerificar: "Verificar",
    btnCerrarSesion: "Salir"
  },
  tramite: {
    title: "Lista de trámites"
  },
  solicitud: {
    title: "Formulario de solicitud de trámite",
    datos_titular: `<strong>Titular del documento.-</strong> Son los datos de la persona a la cual pertenecerá el documento legalizado/certificado.`
  },
  seguimiento: {
    title: "Seguimiento de su trámite"
  },
  verificar: {
    title: "Verificar documento legalizado/certificado"
  },
  BUSCAR_TRAMITE: "Buscar trámite",
  PRECIO: "Precio",
  VER_DETALLES: "Ver detalles",
  SOLICITAR_LEGALIZACION: "Solicitar legalización",
  SOLICITAR_CERTIFICACION: "Solicitar certificación",
  ESCRIBIR_TRAMITE: "Escriba aquí el trámite que desea buscar."
};



// WEBPACK FOOTER //
// ./src/lang/es/messages.js